import {Paper as GWCPaper} from '@yandex-taxi/go-web-components'

/** @deprecated use `Paper` from '@yandex-delivery/blocks' */
export const Paper = GWCPaper
